module.exports = __webpack_public_path__ + "img/img-16.35e9f11f.png";